<template>
  <div>
    <div>
      <!-- Filters Toolbar -->
      <div class="has-background-white rounded-lg pa-md mb-xxs">
        <div class="columns">
          <div class="column">
            <PoFilters :applied-filters="filters" @filter="filter" />
          </div>
          <div class="column is-narrow">
            <b-select v-model="orderBy" expanded @input="sort" size="is-medium">
              <option value="id_desc">Most Recent</option>
              <option value="id_asc">Oldest</option>
            </b-select>
          </div>
          <div v-role="'create-purchase-order'" class="column is-narrow">
            <b-button type="is-primary" outlined size="is-medium" @click="showCreatePoModal = true">Add Funding Details</b-button>
          </div>
        </div>
      </div>
      <!-- Actions Toolbar -->
      <div class="has-background-white rounded-lg px-md py-md mb-xxs">
        <div class="columns is-vcentered is-mobile">
          <div class="column">
            <div class="has-text-right is-size-7">
              <p v-if="loading">Loading...</p>
              <p v-else-if="total === 1">1 order found</p>
              <p v-else>{{ total }} orders found</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Results -->
      <div style="overflow-x:auto" class="mb-md">
        <b-table
          :data="results"
          :checked-rows.sync="selected"
          :mobile-cards="false"
          :loading="loading"
          hoverable
          class="is-size-7">
          <b-table-column
            label="ID"
            width="64"
            centered
            cell-class="nowrap"
            v-slot="props">
            <span class="has-text-grey-light">{{ props.row.id }}</span>
          </b-table-column>
          <b-table-column
            label="Type"
            width="96"
            centered
            v-slot="props">
            <FundingTypePresenter :order="props.row" :abbreviate="true" />
          </b-table-column>
          <b-table-column
            label="Identifier"
            width="128"
            cell-class="nowrap"
            v-slot="props">
            <span v-if="props.row.client_po_number">{{ props.row.client_po_number }}</span>
            <span v-else class="has-text-grey-light">--</span>
          </b-table-column>
          <b-table-column
            label="Name"
            cell-class="nowrap"
            v-slot="props">
            <p class="">
              <router-link
                class="has-text-weight-bold"
                :to="{ name: 'network.order', params: { code: context.code, id: props.row.id } }">
                {{ props.row.name }}
              </router-link>
            </p>
            <p class="has-text-grey">{{ props.row.client.name }}</p>
          </b-table-column>
          <b-table-column
            label="Total Budget"
            cell-class="nowrap"
            numeric
            v-slot="props">
            <Currency :value="props.row.total_budget" />
          </b-table-column>
          <b-table-column
            field="status"
            label="Status"
            v-slot="props"
            centered
            width="128">
            <StatusPresenter :order="props.row" />
          </b-table-column>
          <template slot="empty">
            <div class="py-xxl has-text-grey has-text-centered">
              {{ (loading) ? "Loading data..." : 'No purchase orders found!' }}
            </div>
          </template>
        </b-table>
      </div>
      <b-pagination
        :total="total"
        :current.sync="currentPage"
        :rounded="true"
        :per-page="perPage"
        @change="paginate" />
    </div>
    <!-- Modal: Create Purchase Order -->
    <b-modal
      has-modal-card
      scroll="keep"
      :active.sync="showCreatePoModal"
      :can-cancel="['x', 'esc']"
      ><CreatePoModal @po:created="redirect" />
    </b-modal>
  </div>
</template>

<script>
import Filterable from '@/mixins/Filterable'
import PoFilters from '../components/List/PoFilters'
import FundingTypePresenter from '@/components/Models/PurchaseOrder/Presenters/FundingType'
import StatusPresenter from '@/components/Models/PurchaseOrder/Presenters/Status'
import CreatePoModal from '@/components/Models/PurchaseOrder/Modals/CreatePoModal'
import { mapGetters } from 'vuex'

export default {
  components: {
    CreatePoModal,
    PoFilters,
    FundingTypePresenter,
    StatusPresenter
  },
  computed: {
    ...mapGetters(['api', 'context']),
    endpoint () {
      return this.api.route + '/purchase-orders'
    }
  },
  data: function () {
    return {
      key: 'pos',
      showCreatePoModal: false,
      alwaysAttach: {
        approved: 1
      }
    }
  },
  methods: {
    redirect (po) {
      this.$router.push({
        name: 'network.order',
        params: { code: this.context.code, id: po.id }
      })
    }
  },
  mounted () {
    this.load()
  },
  mixins: [Filterable]
}
</script>
